/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const TABS_IDS = {
  LISTING_ATTRIBUTES: 'listingAttributes',
  PUBLISHED_IMAGES: 'publishedImages',
};
